var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{staticClass:"grey lighten-2"},[_vm._v(" Ärende ")]),_c('OdocForm',{attrs:{"locations":_vm.locations,"case-types":_vm.caseTypes,"readonly":true}}),_c('v-divider'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"rounded":""},on:{"click":_vm.closeModal}},[_vm._v("Stäng")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }